module.exports = __webpack_public_path__ + "img/icon_result_error.ce8b2206.png";